export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-b9b1f2f282a2e8e668ec5964f8e69000.woff";